import { render, staticRenderFns } from "./VideoUploader.vue?vue&type=template&id=320fcd1f&scoped=true"
import script from "./VideoUploader.vue?vue&type=script&lang=js"
export * from "./VideoUploader.vue?vue&type=script&lang=js"
import style0 from "./VideoUploader.vue?vue&type=style&index=0&id=320fcd1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320fcd1f",
  null
  
)

export default component.exports